import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _Config } from "@discovery/common-dplus/lib/state";
import * as M from "@discovery/prelude/lib/data/maybe";
import { useUser } from "../../utils/hooks";
const SearchView = React.lazy(() => import("./view"));
const getProps = (data) => {
    return data;
};
const Search = ({ environment }) => {
    const [configM] = useGlobalState(_Config);
    const { isAnonymous, premiumPackagesM } = useUser();
    const webAuthRedirectionUrl = environment.authService.protocol + "://" + environment.authService.domain;
    // CONFIG
    const premiumPackages = M.fromMaybe(premiumPackagesM, [""]);
    const parentalLockM = M.chain((x) => x.parentalLock, configM);
    const minimumAgeM = M.chain((x) => x.minimumAge, parentalLockM);
    const ageConstraint = M.fromMaybe(minimumAgeM, 0);
    return (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement(SearchView, { read: environment, premiumPackages: premiumPackages, anonymous: isAnonymous, webAuthRedirectionUrl: webAuthRedirectionUrl, ageConstraint: ageConstraint })));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, Search);

